import React, { FC, ReactNode } from 'react';
import FieldCheckbox from '../../atoms/field-checkbox/field-checkbox';

interface Props {
  layout?: 'vertical' | 'horizontal';
  error?: boolean;
  options: {
    value: string | number | null;
    label: ReactNode;
    disabled?: boolean;
  }[];
  value?: string | number | null;
  onChange?: (value: string | number) => void;
}

const FieldRadioGroup: FC<Props> = ({
  layout,
  error,
  options,
  value,
  onChange,
}: Props) => {
  const horizontalLayout =
    layout === 'horizontal' ? 'md:flex-row md:space-y-0 md:space-x-6' : '';

  return (
    <div className={`flex flex-col space-y-3 ${horizontalLayout}`}>
      {options.map((option) => (
        <FieldCheckbox
          key={String(option.value)}
          theme="radio"
          label={option.label}
          disabled={option.disabled}
          error={error}
          value={value === option.value}
          onChange={() => onChange(option.value)}
        />
      ))}
    </div>
  );
};

FieldRadioGroup.defaultProps = {
  layout: 'vertical',
  error: false,
  value: null,
  onChange: null,
};

export default FieldRadioGroup;
